import React from 'react';

export default function StarRating({ value, onChange, readOnly, size = 18 }) {
  const stars = [1, 2, 3, 4, 5];
  return (
    <span style={{ display: 'inline-flex', gap: 4, alignItems: 'center' }} role={onChange ? 'radiogroup' : undefined}>
      {stars.map((s) => {
        const filled = value != null && s <= value;
        return (
          <button
            key={s}
            type="button"
            disabled={readOnly}
            onClick={() => onChange && onChange(s)}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: readOnly ? 'default' : 'pointer',
              fontSize: size,
              lineHeight: 1,
              color: filled ? '#FF6B00' : '#d1d5db',
            }}
            aria-label={`${s} star${s > 1 ? 's' : ''}`}
          >
            ★
          </button>
        );
      })}
    </span>
  );
}
